module.exports = require("./InteractionsService")
